import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./styles.css";
import "./g0-p1.css";
import "./p2-entry.css";
import "./p3-inventory.css";
import "./p4-sold.css";
import "./p5-p7.css";

createRoot(document.getElementById("root")).render(<StrictMode><App /></StrictMode>);
